import { render } from "./Index.vue?vue&type=template&id=0bf1d1a9"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"
script.render = render

export default script